import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  return (
    <NavContainer>
      <LinkTo to="/">
        <Wrapper>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="18px"
            viewBox="0 0 24 24"
            width="18px"
            fill="#000000"
          >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
          </svg>
          <IconDescription>Home</IconDescription>
        </Wrapper>
      </LinkTo>
      <LinkTo to="/Tracker">
        <Wrapper>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 0 24 24"
            width="20px"
            fill="black"
          >
            <path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" />
          </svg>
          <IconDescription>Tracker</IconDescription>
        </Wrapper>
      </LinkTo>
      <LinkTo to="/converter">
        <Wrapper>
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 388 372"
          >
            <path d="M114 13.6c-17.5 2.5-27.1 5.3-39.5 11.6C22.2 51.5-.1 114.8 24 168.5c10.6 23.6 33.3 45.8 56.9 55.6 14.9 6.2 24.9 8.2 42.1 8.3l15.5.1.1 15.5c.1 17.5 2.2 27.9 8.8 43 24.2 55.9 91.5 81.4 146.4 55.5 13.1-6.2 22.1-12.5 31.7-22 26.1-26.2 37.5-64 30-99.6-8.8-41.6-39.4-73.5-81.3-84.6-8.3-2.2-11.9-2.6-25.2-2.7l-15.5-.1-.1-15.5c-.1-17.2-2.1-27.2-8.3-42.1-9.8-23.6-32-46.3-55.6-56.9-16.8-7.5-40.4-11.5-55.5-9.4zM145.2 29c43.8 9.6 74.9 48.4 75.1 93.5.1 18.2.4 17.5-11.1 21.9-29.5 11.2-52.6 34.3-63.8 63.8-4.4 11.5-3.7 11.2-21.9 11.1-45-.2-83.9-31.4-93.5-75.1-2.4-10.6-2.6-28.8-.6-39.4 7.4-38.3 37.4-68.6 75.6-76.3 10.1-2 29.9-1.8 40.2.5zm124.6 124.1c35 8 62.2 34.7 71.8 70.4 1.5 5.5 1.9 10.5 1.9 23.5 0 17.6-.8 22.3-6.1 35.8-12.1 30.8-41 54-73.6 59.2-9.9 1.6-31 .8-39.8-1.6-34.6-9.2-60.7-35.5-69.7-70.4-3.4-12.9-3.5-31.4-.4-44.3 8.5-35.4 34.3-62.4 68.7-71.8 15.3-4.2 31.4-4.5 47.2-.8z" />
            <path d="M122 53.9v4.9l-5.2 1.1c-11.6 2.5-19.3 8.3-24.5 18.3-2.3 4.5-2.7 6.6-2.7 13.3-.1 14.3 5.9 21.9 20.5 26.4 4.1 1.2 8 2.4 8.7 2.6.9.3 1.2 5.4 1.2 20.9v20.5l-2.8-.8c-9.9-2.9-16.7-9.8-17.8-18.2l-.7-4.9h-12l.6 5.1c.9 7.2 4.8 15 10.2 20.4 5 5.1 10.4 7.8 18.3 9.6l5.2 1.1V186h8v-11.6l7.2-1.7c16.1-3.8 25.8-15.7 25.8-31.8 0-14.8-6.6-22.5-25-29l-7.5-2.7-.3-18.6C129 72.4 129 72 131 72c5.2 0 12.8 6.8 15 13.4 1.2 3.6 1.2 3.6 7.1 3.6 5 0 5.9-.3 5.9-1.8-.1-3-4.6-12.9-7.9-17.1C148 66.2 137.5 60 133.9 60c-4 0-4.9-1.1-4.9-6.1V49h-7v4.9zM120 90c0 9.9-.3 18-.7 18-2.6-.1-12.2-6.2-14-9-4.1-5.9-2.8-17.5 2.3-22.2 2.8-2.5 7.6-4.8 10.2-4.8h2.2v18zm18 37.3c7.7 3.8 10 7.4 10 15.5 0 9.3-3.7 14.8-11.9 17.7-7.5 2.6-7.1 3.6-7.1-17.5 0-14.5.3-19 1.3-19 .6 0 4.1 1.5 7.7 3.3zM232.8 191.2l-.3 8.3-9.2.3-9.3.3V301h19v16h10v-16h10v16h10v-16.6l5.5-1.8c10.7-3.3 17.7-11.3 19.1-21.8 1.9-13.9-4.8-24-18.8-28.2l-4.3-1.3 4.3-1.8c5.4-2.2 11.6-9.2 13.2-15 3.3-11.7-3.6-24.7-15.1-28.5l-3.9-1.3v-17.8l-4.7.3-4.8.3-.3 8.2-.3 8.3h-9.8l-.3-8.3-.3-8.2-4.7-.3-4.7-.3-.3 8.3zm28.7 21.4c5.8 3 8.5 7.5 8.5 14.1 0 7.1-2.2 10.7-8.4 13.8-4.6 2.3-6.1 2.5-19.8 2.5H227v-33.2l15.3.4c12.9.3 15.9.7 19.2 2.4zm-.5 42.5c9 1.9 14 8 14 16.9 0 5.7-1 8.1-4.8 12.3-4.2 4.4-10.5 5.7-27.9 5.7H227v-36h14.5c7.9 0 16.7.5 19.5 1.1zM271.2 35.3 252 54.5 271.5 74 291 93.5l4.7-4.8 4.8-4.7-10.8-10.8c-5.9-5.9-10.7-11.1-10.7-11.5 0-.5 8.9-.7 19.8-.5 19.2.3 19.8.4 25.4 3.1 7.1 3.5 12.9 9.1 16.5 15.9l2.8 5.3.5 25.5.5 25.5 6.8.3 6.7.3v-22.8c0-25.4-1-31.7-6.1-41.3-3.7-7-11.6-15.1-18.4-19-9.2-5.2-14-6-35.2-6-10.6 0-19.3-.3-19.3-.8 0-.4 4.7-5.4 10.5-11.2 5.8-5.8 10.5-10.8 10.5-11.2 0-.9-8-8.8-8.9-8.8-.3 0-9.3 8.7-19.9 19.3zM21.2 258.7c.4 24 .6 26.2 2.7 31.5 5.3 13.5 15.5 24 27.9 28.9 5 2 7.9 2.4 23.5 2.7 9.7.2 17.7.7 17.7 1 0 .4-4.8 5.5-10.7 11.4L71.5 345l4.8 4.7 4.7 4.8 19.5-19.5 19.5-19.5-19.5-19.5L81 276.5l-4.7 4.8-4.8 4.7 10.8 10.8c5.9 5.9 10.7 11.1 10.7 11.6 0 .4-7.3.6-16.2.4-15.2-.3-16.7-.5-22-3-10.7-5-17.9-14.6-19.8-26.4-.6-3.3-1-15-1-26.2V233H20.8l.4 25.7z" />
          </svg>
          <IconDescription>Convert</IconDescription>
        </Wrapper>
      </LinkTo>
    </NavContainer>
  );
};

export default Navbar;

const NavContainer = styled.nav`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 90%;
  height: 52px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 20px;
  position: fixed;

  background-color: white;
  border-radius: 50px;
  z-index: 10;

  background-color: #f0f2f8;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  @media (min-width: 400px) {
    width: 400px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LinkTo = styled(NavLink)`
  display: flex;
  justify-content: center;
  opacity: 0.5;
  width: 100px;
  height: 36px;
  text-decoration: none;
  border-radius: 50px;

  &.active {
    background: var(--bg-color-gradientblue);
    opacity: 1;
    color: #fff;
    svg {
      fill: #fff;
    }
  }
`;

const IconDescription = styled.p`
  padding-left: 2px;
`;
